import { pushNotification } from "../../pushNotification";

export function aiCodeMetrics(args) {
  const { token, permissionCheckPath, downloadPath, installerDownloadPath } =
    args || {};

  const handleHttpError = (status, isDownloading) => {
    if (status === 403) {
      pushNotification({
        title: "Not authorized",
        desc: "You do not have permission to download the source code.",
        success: false,
      });
    } else if (isDownloading) {
      pushNotification({
        title: "Download failed",
        desc: "Something went wrong while downloading the source code. Please try again.",
        success: false,
      });
    } else {
      pushNotification({
        title: "Error",
        desc: "Something went wrong while checking permissions. Please try again.",
        success: false,
      });
    }
  };

  const downloadFile = async (url, defaultFilename) => {
    const response = await fetch(url);
    if (!response.ok) {
      handleHttpError(response.status, true);
      return false;
    }

    const blob = await response.blob();
    const disposition = response.headers.get("Content-Disposition") || "";
    const filenameMatch = disposition.match(/filename=(.+)/);
    const filename = filenameMatch ? filenameMatch[1] : defaultFilename;
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(objectUrl);
    return true;
  };

  return {
    showAiCodeMetricsRegenerateTokenModal: false,
    showAiCodeMetricsDownloadSourceModal: false,
    aiCodeMetricsSetupDismissed: false,

    copyToken() {
      navigator.clipboard.writeText(token).then(() => {
        pushNotification({
          title: "Token copied to clipboard",
          desc: "Paste it wherever you would like.",
        });
      });
    },

    async checkPermissionAndOpenModal() {
      try {
        const response = await fetch(permissionCheckPath, {
          headers: { Accept: "application/json" },
        });
        if (response.ok) {
          this.showAiCodeMetricsDownloadSourceModal = true;
        } else {
          handleHttpError(response.status, false);
        }
      } catch {
        handleHttpError(null, false);
      }
    },

    async downloadSource() {
      try {
        const success = await downloadFile(
          downloadPath,
          "ai-code-metrics-source.tar.gz",
        );
        if (success) {
          this.showAiCodeMetricsDownloadSourceModal = false;
        }
      } catch (e) {
        this.showAiCodeMetricsDownloadSourceModal = false;
        handleHttpError(null, true);
      }
    },

    async downloadInstaller(platform) {
      try {
        const response = await fetch(permissionCheckPath, {
          headers: { Accept: "application/json" },
        });
        if (!response.ok) {
          handleHttpError(response.status, false);
          return;
        }

        const platformExtensions = {
          macos: "pkg",
          windows: "msi",
          linux: "tar.gz",
        };
        const extension = platformExtensions[platform] || platform;
        const url = installerDownloadPath.replace(":platform", platform);
        await downloadFile(url, `ai-code-metrics-installer.${extension}`);
      } catch {
        handleHttpError(null, true);
      }
    },

    async downloadInstallerMacOS() {
      await this.downloadInstaller("macos");
    },

    async downloadInstallerWindows() {
      await this.downloadInstaller("windows");
    },

    async downloadInstallerLinux() {
      await this.downloadInstaller("linux");
    },
  };
}
